var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.547,
    height: 32.714,
    viewBox: "0 0 30.547 32.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2312",
    "data-name": "Group 2312",
    transform: "translate(-16.956 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M107.832,0h11.079l9.78,9.782V28.565a4.161,4.161,0,0,1-4.149,4.149h-16.71a4.16,4.16,0,0,1-4.147-4.149V4.149A4.16,4.16,0,0,1,107.832,0Z",
    transform: "translate(-81.188)",
    fill: "#e5252a",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M341.982,0l9.78,9.782h-8.725a1.057,1.057,0,0,1-1.054-1.056Z",
    transform: "translate(-304.259)",
    fill: "#b71d21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M17.866,218.02H40.4a.913.913,0,0,1,.91.911V227.2a.913.913,0,0,1-.91.91H17.866a.913.913,0,0,1-.91-.91v-8.265A.913.913,0,0,1,17.866,218.02Z",
    transform: "translate(0 -204.089)",
    fill: "#b71d21",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M85.123,244.4h-1.7a.528.528,0,0,0-.528.528v5.657a.528.528,0,0,0,1.056,0v-1.657h1.171A2.23,2.23,0,0,0,87.35,246.7v-.073A2.23,2.23,0,0,0,85.123,244.4Zm1.171,2.3a1.173,1.173,0,0,1-1.171,1.171H83.951v-2.415h1.171a1.173,1.173,0,0,1,1.171,1.171v.073Zm4.512-2.3h-1.7a.528.528,0,0,0-.528.528v5.657a.528.528,0,0,0,.528.528h1.7a2.23,2.23,0,0,0,2.228-2.228v-2.258A2.23,2.23,0,0,0,90.806,244.4Zm1.171,4.486a1.173,1.173,0,0,1-1.171,1.171H89.635v-4.6h1.171a1.173,1.173,0,0,1,1.171,1.171Zm3.444-3.43v1.462h2.448a.528.528,0,1,1,0,1.056H95.421v2.611a.528.528,0,0,1-1.056,0v-5.657a.528.528,0,0,1,.528-.528h3.4a.528.528,0,0,1,0,1.056Z",
    transform: "translate(-61.726 -228.783)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PDF_icon.0623919a404a7c1f809a089f5a538d22.svg";
export { ForwardRef as ReactComponent };